function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

function SvgDiscord(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.007 512.007",
    style: {
      enableBackground: "new 0 0 512.007 512.007"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#827DDC"
    },
    cx: 256.003,
    cy: 256.003,
    r: 256.003
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6E64C3"
    },
    d: "M380.117,113.567c-5.628-5.629-13.404-9.112-21.994-9.112H153.877c-17.176,0-31.1,13.924-31.1,31.1 V339.8c0,8.586,3.479,16.36,9.106,21.987l0,0l149.006,149.006C410.592,498.278,512,388.987,512,256.001 c0-3.616-0.094-7.211-0.242-10.791L380.117,113.567z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5046AF"
    },
    d: "M358.123,104.456H153.877c-17.176,0-31.1,13.924-31.1,31.1v204.246c0,17.176,13.924,31.1,31.1,31.1 h172.607l-7.006-28.023l69.743,64.669c0-7.558,0-264.62,0-271.99C389.222,118.38,375.298,104.456,358.123,104.456z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M323.46,190.367c0,0-12.896-13.653-42.177-15.629v4.311c0,0,16.06-0.933,35.94,18.636 c-15.006-10.796-36.413-17.559-60.191-17.559s-45.185,6.762-60.191,17.559c19.88-19.569,35.94-18.636,35.94-18.636v-4.311 c-29.281,1.976-42.177,15.629-42.177,15.629c-22.312,28.74-23.569,91.613-23.569,91.613c21.017,25.328,47.424,22.096,47.424,22.096 l9.7-14.011c-12.509-3.384-21.442-11.153-26.811-17.203c14.979,10.587,36.171,17.203,59.684,17.203s44.705-6.615,59.684-17.203 c-5.369,6.049-14.302,13.819-26.811,17.203l9.7,14.011c0,0,26.407,3.234,47.424-22.096 C347.031,281.979,345.773,219.107,323.46,190.367z M229.01,264.196c-8.433,0-15.269-7.263-15.269-16.224 c0-8.96,6.836-16.224,15.269-16.224c8.433,0,15.269,7.264,15.269,16.224S237.443,264.196,229.01,264.196z M285.056,264.196 c-8.433,0-15.269-7.263-15.269-16.224c0-8.96,6.836-16.224,15.269-16.224c8.433,0,15.269,7.264,15.269,16.224 S293.49,264.196,285.056,264.196z"
  }), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscord);
export default __webpack_public_path__ + "static/media/discord.b16e6243.svg";
export { ForwardRef as ReactComponent };